/* mx-slider.js · slider de portada sin librerías (scroll-snap). Flechas, puntos, teclado y carga diferida de diapositivas 2+. */
(function () {
  'use strict';
  function init(root) {
    if (root.__mx) return; root.__mx = true;
    var track = root.querySelector('[data-mx-track]');
    var slides = track ? track.children : [];
    if (!track || slides.length < 2) return;
    var dots = root.querySelectorAll('.mx-slider__dot');
    var cur = 0;
    var hydrated = false;

    function hydrate() {
      if (hydrated) return;
      hydrated = true;
      var sources = root.querySelectorAll('source[data-mx-srcset]');
      for (var s = 0; s < sources.length; s++) {
        sources[s].srcset = sources[s].getAttribute('data-mx-srcset');
        sources[s].removeAttribute('data-mx-srcset');
      }
      var imgs = root.querySelectorAll('img[data-mx-src]');
      for (var m = 0; m < imgs.length; m++) {
        var srcset = imgs[m].getAttribute('data-mx-srcset');
        if (srcset) {
          imgs[m].srcset = srcset;
          imgs[m].removeAttribute('data-mx-srcset');
        }
        imgs[m].src = imgs[m].getAttribute('data-mx-src');
        imgs[m].removeAttribute('data-mx-src');
      }
    }

    function go(i) {
      hydrate();
      cur = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[cur].offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    function mark() {
      var w = track.clientWidth || 1;
      cur = Math.round(track.scrollLeft / w);
      for (var k = 0; k < dots.length; k++) { dots[k].classList.toggle('is-on', k === cur); dots[k].setAttribute('aria-current', k === cur ? 'true' : 'false'); }
    }
    var prev = root.querySelector('[data-mx-prev]'), next = root.querySelector('[data-mx-next]');
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
    for (var d = 0; d < dots.length; d++) (function (n) { dots[n].addEventListener('click', function () { go(n); }); })(d);
    track.addEventListener('touchstart', hydrate, { passive: true, once: true });
    track.addEventListener('pointerdown', hydrate, { passive: true, once: true });
    track.addEventListener('scroll', function () { hydrate(); window.requestAnimationFrame(mark); }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
    });
    mark();
  }
  function boot() { var n = document.querySelectorAll('[data-mx-slider]'); for (var i = 0; i < n.length; i++) init(n[i]); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
